var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-image-group"},[_c('img',{staticClass:"view-image",attrs:{"src":_vm.imagePath},on:{"click":_vm.closePanel}})])}
var staticRenderFns = []

export { render, staticRenderFns }